import Int32LookupListResultModelBase from '../_generated/modelBases/int32-lookup-list-result-model-base';

export default class Int32LookupListResultModel extends Int32LookupListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
